module.exports = __webpack_public_path__ + "static/adam-grant-d085e1ee5cc6242488b99ff42facb56d.jpg";